import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import CategoryService from "../../../../services/CategoryService";
import BaseService from "../../../../services/BaseService";

const AddCategoryModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		image: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const categoryService = new CategoryService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name_en: item?.name_en,
				name_ar: item?.name_ar,
				image: item?.image,
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.image) {
			return;
		}
		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			image: formData?.image,
		};

		setLoading(true);
		if (isAdd) {
			categoryService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			categoryService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData((prev) => ({ ...prev, image: res.data.url }));
			}
		});
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.category}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* Name En */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.english_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english_name}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) =>
									setFormData({
										...formData,
										name_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.arabic_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.arabic_name}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										name_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Image */}
						<Col md={12}>
							<label className="text-label mb-0">{Translate[lang].image}</label>
							<div className="upload">
								<input
									type="file"
									name="image"
									id="image"
									onChange={(e) => fileHandler(e)}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							<p className="mb-0 d-flex gap-8 mt-1 fs-12">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8.00004 14.6666C11.6667 14.6666 14.6667 11.6666 14.6667 7.99992C14.6667 4.33325 11.6667 1.33325 8.00004 1.33325C4.33337 1.33325 1.33337 4.33325 1.33337 7.99992C1.33337 11.6666 4.33337 14.6666 8.00004 14.6666Z"
										stroke="#7B7B7B"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M8 5.33325V8.66659"
										stroke="#7B7B7B"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M7.99634 10.6667H8.00233"
										stroke="#7B7B7B"
										strokeWidth="1.33333"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
								Allowed 1 image PNG, JPEG, JPEG formats only – max size 1 MB
							</p>
							{!!formData?.image && (
								<img
									src={formData?.image}
									alt="category"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.category}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddCategoryModal;
